import { render, staticRenderFns } from "./CharacterListMain.vue?vue&type=template&id=77efe704&"
import script from "./CharacterListMain.vue?vue&type=script&lang=js&"
export * from "./CharacterListMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports